module.exports = __webpack_public_path__ + "img/icon-call.cfd523a6.svg";